"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCirrus = void 0;
const react_1 = require("react");
const contexts_1 = require("../contexts");
function useCirrus() {
    const context = react_1.useContext(contexts_1.CirrusContext);
    react_1.useEffect(() => {
        if (!(context === null || context === void 0 ? void 0 : context.socket)) {
            throw new Error('No Yanzi Socket in the context.');
        }
    }, [context]);
    return context;
}
exports.useCirrus = useCirrus;
//# sourceMappingURL=useCirrus.js.map